var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_615_3750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 8,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C10.4087 10 8.88258 10.6321 7.75736 11.7574C6.63214 12.8826 6 14.4087 6 16V21C6 21.7082 5.81218 22.3971 5.46411 23H18.5359C18.1878 22.3971 18 21.7082 18 21V16C18 14.4087 17.3679 12.8826 16.2426 11.7574C15.1174 10.6321 13.5913 10 12 10ZM22 23C21.4696 23 20.9609 22.7893 20.5858 22.4142C20.2107 22.0391 20 21.5304 20 21V16C20 13.8783 19.1571 11.8434 17.6569 10.3431C16.1566 8.84285 14.1217 8 12 8C9.87827 8 7.84344 8.84285 6.34315 10.3431C4.84285 11.8434 4 13.8783 4 16V21C4 21.5304 3.78929 22.0391 3.41421 22.4142C3.03914 22.7893 2.53043 23 2 23C1.44772 23 1 23.4477 1 24C1 24.5523 1.44772 25 2 25H22V23ZM9.76823 27.135C10.246 26.8579 10.8579 27.0205 11.135 27.4982C11.2229 27.6498 11.3491 27.7756 11.5009 27.863C11.6527 27.9504 11.8248 27.9965 12 27.9965C12.1752 27.9965 12.3473 27.9504 12.4991 27.863C12.6509 27.7756 12.7771 27.6498 12.865 27.4982C13.1421 27.0205 13.754 26.8579 14.2318 27.135C14.7095 27.4121 14.8721 28.024 14.595 28.5018C14.3313 28.9564 13.9528 29.3337 13.4973 29.5961C13.0419 29.8584 12.5256 29.9965 12 29.9965C11.4744 29.9965 10.9581 29.8584 10.5027 29.5961C10.0472 29.3337 9.66872 28.9564 9.405 28.5018C9.12788 28.024 9.2905 27.4121 9.76823 27.135Z",
    fill: "#061938"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_615_3750)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 24,
    height: 24,
    fill: "black"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.418 3.96V3.047H17.486V11H16.474V3.96H15.418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d7568ea1c4e2d9471dcf0a0527d85c30.svg";
export { ForwardRef as ReactComponent };